<template>
  <div class="page">
    <com-banner></com-banner>
    <div class="header">
      <div class="header-avatar"><img :src="info.avatar" /></div>
      <div class="header-d">
        <div class="header-account">{{ info.acc }}</div>
        <!-- <div class="header-p" v-if="info.progress">谢谢你帮我加速了{{ progress }}%，<span>送你一次抽鞋</span>的机会，快试试运气吧</div> -->
        <!-- <div class="header-p">谢谢你帮我助力，<span>送你一次抽鞋</span>的机会，快试试运气吧</div> -->
        <div class="header-tip2"></div>
      </div>
    </div>
    <div class="shoe">
      <div class="shoe-d">
        <div class="page2-shoe">
          <div class="swiper-container">
            <div class="shoe-list swiper-wrapper">
              <div class="shoe-item swiper-slide" v-for="item in list" :key="item.id">
                <img :src="`./img/${item.icon}.png`" />
              </div>
            </div>
          </div>
          <!-- <div class="shoe-name">{{ list[current].title }}</div> -->
        </div>
      </div>
    </div>
    <div class="main">
      <div class="btn btn2" @click="handleGo"></div>
    </div>
    <com-footer></com-footer>
  </div>
</template>

<script>
import comBanner from '@/components/banner'
import comFooter from '@/components/footer'

import Swiper from 'swiper'
import { shoes } from '@/config/index'
import { getRandomIndex } from '@/utils/index'

export default {
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      swiper: null,
      current: 0,
      list: shoes,
      target: -1
    }
  },
  computed: {
    progress() {
      let progress = parseInt(this.info.progress)
      isNaN(progress) && (progress = 10000)
      progress = progress / 100
      return progress.toFixed(2)
    }
  },
  mounted() {
    const _this = this
    this.swiper = new Swiper('.swiper-container', {
      speed: 1000,
      freeMode: true,
      slidesPerView: 'auto',
      centeredSlides: true,
      loop: true,
      autoplay: {
        delay: 1,
        disableOnInteraction: false
      },
      initialSlide: _this.current,
      allowTouchMove: false,
      on: {
        slideChangeTransitionEnd: function() {
          // _this.current = this.realIndex
          _this.target !== -1 && this.slideToLoop(_this.target, 1, false)
        }
      }
    })
  },
  methods: {
    swiperPlay(index) {
      return new Promise((resolve, reject) => {
        this.swiper.params.speed = 100
        setTimeout(() => {
          this.swiper.params.autoplay = false
          this.target = index
          // this.$nextTick(() => {
          //   this.swiper.slideToLoop(index, 100, false)
          //   // this.swiper.slideTo(index, 100, false)
          // })
          resolve()
        }, 2000)
      })
    },
    async handleGo() {
      const weight = shoes.map(item => item.weight)
      const index = getRandomIndex(weight)
      await this.swiperPlay(index)
      const shoeId = shoes[index].id
      this.$emit('go', shoeId)
    }
  },
  components: {
    comBanner,
    comFooter
  }
}
</script>

<style lang="less">
.shoe {
  .swiper-slide {
    // padding: 0 calc(50vw * .15);
    // width: 50vw;
  }
  .swiper-container-free-mode>.swiper-wrapper {
    transition-timing-function: linear;
  }
}
</style>

<style lang="less" scoped>
.page2-shoe {
  .shoe-list {
    text-align: center;
    .shoe-item img{
      max-width: 100%;
      max-height: 5.4rem;
    }
  }
  .shoe-name {
    margin-top: .3rem;
    line-height: .6rem;
    text-align: center;
    font-size: .4rem;
    color: #fff;
  }
}
@media screen and (min-height: 571px) and (max-height: 680px) {
  .page2-shoe {
    .shoe-list {
      .shoe-item img{
        max-height: 4.6rem;
      }
    }
  }
}
@media screen and (min-height: 521px) and (max-height: 570px) {
  .page2-shoe {
    .shoe-list {
      .shoe-item img{
        max-height: 4rem;
      }
    }
  }
}
@media screen and (min-height: 461px) and (max-height: 520px) {
  .page2-shoe {
    .shoe-list {
      .shoe-item img{
        max-height: 4rem;
      }
    }
    .shoe-name {
      margin-top: 0;
      line-height: .45rem;
      font-size: .3rem;
    }
  }
}
@media screen and (max-height: 460px) {
  .page2-shoe {
    .shoe-list {
      .shoe-item img{
        max-height: 3rem;
      }
    }
    .shoe-name {
      margin-top: 0;
      line-height: .45rem;
      font-size: .3rem;
    }
  }
}
</style>
